import * as React from "react"
import "./demo_section.scss"

import { handleResourcesImages } from "../../hooks/handleResourcesImages";


const ResourcesDemo = ({ ...props  }) => {

    return (
    <div className="resources-demo-container p-sm-3" >
        {handleResourcesImages("Schedule a Demo")}
        <div className="col-md-12 col-lg-5 d-flex flex-column justify-content-md-center resources-demo-content">
          <p className="strapline">{props.strapline}</p>
          <h2 className="text-white">{props.headlineBold}</h2>
          <p className="py-2 caption text-white">{props.paragraph}</p>
            <div className="text-start pb-sm-2 align-left d-flex flex-row">
              <div>
                <a href={props.buttonHref}><button className="text-light white-cta-button p-2">{props.buttonText}</button></a>
              </div>
              <div className="justify-content-center">
                <ul>
                  <li>{props.info}</li>
                </ul>
              </div>
            </div>
        </div>
    </div>
  )
}

export default ResourcesDemo